export default __webpack_public_path__ + "static/media/3248.3891beb3.png";